// Shared client-side URL validation for the business "website" field.
//
// Matches the backend `_valid_https_url` in server.py so users see the same
// verdict client-side that Stripe Connect will enforce server-side.
//
// Returns:
//   { ok: true,  normalized: "https://example.com" }  when valid
//   { ok: false, error: "…" }                          when invalid
//   { ok: true,  normalized: "" }                      when empty (optional field)

export function validateBusinessWebsite(raw) {
  if (raw === undefined || raw === null) return { ok: true, normalized: "" };
  const s = String(raw).trim();
  if (!s) return { ok: true, normalized: "" };

  // Reject obvious non-URL values fast
  if (s.startsWith("@") || /\s/.test(s)) {
    return { ok: false, error: 'Please enter a full URL such as "https://example.com".' };
  }

  let candidate = s;
  const lower = candidate.toLowerCase();
  if (!lower.startsWith("http://") && !lower.startsWith("https://")) {
    // Auto-upgrade bare "example.com"
    const beforeQuery = candidate.split("?")[0];
    if (candidate.includes(".") && !beforeQuery.includes("/")) {
      candidate = "https://" + candidate;
    } else {
      return {
        ok: false,
        error: 'Please enter a full URL such as "https://example.com" — not a social handle or app name.',
      };
    }
  }
  // Upgrade http → https
  if (!candidate.toLowerCase().startsWith("https://")) {
    candidate = "https://" + candidate.split("://", 2)[1];
  }
  try {
    const host = candidate.split("://", 2)[1].split("/", 1)[0];
    if (!host.includes(".") || host.length < 3) {
      return { ok: false, error: 'That doesn\'t look like a real domain (needs a "." such as "example.com").' };
    }
  } catch {
    return { ok: false, error: "Please enter a valid URL." };
  }
  return { ok: true, normalized: candidate };
}
